<div class="ui-g">

  <!-- Company Column -->
  <div #company data-testid="company" class="ui-g-4" [ngClass]="{'order-2': activeTab === 0 || activeTab === 2}">
    <div #companyHeader data-testid="companyHeader" class="elements-header">
      <span>{{'menu.administrationCompanies' | translate}}</span>
      <button
        pButton
        *ngIf="activeTab === 1"
        class="create-btn"
        pTooltip="{{ 'common.create' | translate }}"
        (click)="openCreationDialog()"
        label="{{ 'common.create' | translate | uppercase }}">
      </button>
    </div>
    <div class="elements-list" *ngIf="companies && companies.length > 0">
      <div class="element" *ngFor="let association of companies" [ngClass]="{'selected-element': association.selected}">
        <div>
          <p-checkbox
            *ngIf="activeTab !== 1"
            class="ch-checkbox"
            [(ngModel)]="association.associated"
            [binary]="true"
            (onChange)="associateCompany(association)">
          </p-checkbox>
          <span *ngIf="activeTab !== 2">{{association.name}}</span>
          <span *ngIf="activeTab === 2">{{association.company_name}}</span>
        </div>
        <div>
          <p-button
            class="association-edit-btn"
            [disabled]="activeTab !== 1 && !association.associated"
            pTooltip="{{ 'common.edit' | translate }}"
            icon="fa fa-pencil"
            styleClass="ui-button-info"
            (onClick)="activeTab === 1 ? openCreationDialog(association) : associateCompany(association)">
          </p-button>
          <p-button
            *ngIf="activeTab === 1"
            class="association-edit-btn"
            pTooltip="{{ 'common.delete' | translate }}"
            icon="fa fa-trash"
            styleClass="ui-button-info"
            (onClick)="deleteCompany(association)">
          </p-button>
          <p-button
            class="association-detail-btn"
            [disabled]="activeTab !== 1 && !association.associated"
            pTooltip="{{ 'common.viewAssociations' | translate }}"
            icon="fa fa-arrow-circle-right"
            styleClass="ui-button-info"
            (onClick)="openCompanyAssociationsColumn(association)">
          </p-button>
        </div>
      </div>
    </div>
  </div>

  <!-- Application Column-->
  <div #application data-testid="application" class="ui-g-4" [ngClass]="{'order-3': activeTab === 0, 'order-1': activeTab === 2}">
    <div #applicationHeader data-testid="applicationHeader" class="elements-header">
      <span>{{'menu.administrationApplications' | translate}}</span>
      <button
        pButton
        *ngIf="activeTab === 2"
        class="create-btn"
        pTooltip="{{ 'common.create' | translate }}"
        (click)="openCreationDialog()"
        label="{{ 'common.create' | translate | uppercase }}">
      </button>
    </div>
    <div class="elements-list" *ngIf="applications && applications.length > 0">
      <div class="element" *ngFor="let association of applications" [ngClass]="{'selected-element': association.selected}">
        <div>
          <p-checkbox
            *ngIf="activeTab !== 2"
            class="ch-checkbox"
            [(ngModel)]="association.associated"
            [binary]="true"
            (onChange)="associateApp(association)">
          </p-checkbox>
          <span *ngIf="activeTab !== 2">{{association.application_name }}</span>
          <span *ngIf="activeTab === 2">{{association.name }}</span>
        </div>
        <div>
          <p-button
            class="association-edit-btn"
            [disabled]="!association.associated && activeTab !== 2"
            pTooltip="{{ 'common.edit' | translate }}"
            icon="fa fa-pencil"
            styleClass="ui-button-info"
            (onClick)="activeTab === 2 ? openCreationDialog(association) : associateApp(association)">
          </p-button>
          <p-button
            *ngIf="activeTab === 2"
            class="association-edit-btn"
            pTooltip="{{ 'common.delete' | translate }}"
            icon="fa fa-trash"
            styleClass="ui-button-info"
            (onClick)="deleteApp(association)">
          </p-button>
          <p-button
            *ngIf="activeTab !== 0"
            class="association-detail-btn"
            [disabled]="!association.associated && activeTab !== 2"
            pTooltip="{{ 'common.viewAssociations' | translate }}"
            icon="fa fa-arrow-circle-right "
            styleClass="ui-button-info"
            (onClick)="openAppAssociationsColumn(association)">
          </p-button>
        </div>
      </div>
    </div>
  </div>

  <!-- Users Column-->
  <div #user data-testid="user" class="ui-g-4" [ngClass]="{'order-1': activeTab === 0, 'order-3': activeTab === 2}">
    <div #userHeader data-testid="userHeader" class="elements-header">
      <span>{{'menu.administrationUsers' | translate}}</span>
      <!-- Aggiungi il campo di ricerca
      <input type="text" placeholder="Search" pInputText [(ngModel)]="searchTerm" class="search-input" (ngModelChange)="filterUsers($event)"> -->
      <div class="ui-grid-col-8">
        <p-autoComplete
          [style]="{'width':'100%'}"
          class="autoCompleteSearch"
          [suggestions]=""
          (completeMethod)="getFilteredUsers($event)"
          [dropdown]="false"
          field="label"
          placeholder="Login"
          (onClear)="getFilteredUsers($event)"
          [minLength]="3"
        >
        </p-autoComplete>

      </div>
      <button
        pButton
        *ngIf="activeTab === 0"
        class="create-btn"
        pTooltip="{{ 'common.create' | translate }}"
        (click)="openCreationDialog()"
        label="{{ 'common.create' | translate | uppercase }}">
      </button>
    </div>
    <div class="elements-list" *ngIf="users && users.length > 0">
      <div class="element" *ngFor="let association of users" [ngClass]="{'selected-element': association.selected}">

        <div>
          <p-checkbox
            *ngIf="activeTab !== 0"
            class="ch-checkbox"
            [(ngModel)]="association.associated"
            [binary]="true"
            (onChange)="associateUser(association)">
          </p-checkbox>
          <span>{{association.login }}</span>
        </div>
        <div>
          <p-button
            *ngIf="association.flg_state !== '9'"
            class="association-edit-btn"
            [disabled]="activeTab !== 0 && !association.associated"
            pTooltip="{{ 'common.edit' | translate }}"
            icon="fa fa-pencil"
            styleClass="ui-button-info"
            (onClick)="activeTab === 0 ? openCreationDialog(association) : associateUser(association)">
          </p-button>
          <p-button
            *ngIf="
              activeTab === 0 &&
              association.role_type !== 'S' &&
              association.role_type !== 'A' &&
              (authService.user.role === 'S' || authService.user.role === 'A') &&
              association.flg_state !== '9'
            "
            pTooltip="{{ 'users.clone' | translate }}"
            icon="fa fa-clone"
            styleClass="ui-button-info"
            (onClick)="openCloneUserDialog(association)">
          </p-button>
          <p-button
            *ngIf="activeTab === 0 "
            class="association-edit-btn"
            pTooltip="{{ 'common.delete' | translate }}"
            icon="fa fa-trash"
            styleClass="ui-button-info"
            (onClick)="deleteUser(association)">
          </p-button>
          <p-button
            *ngIf="activeTab === 0 && association.flg_state !== '9'"
            class="association-detail-btn"
            pTooltip="{{ 'common.viewAssociations' | translate }}"
            icon="fa fa-arrow-circle-right "
            styleClass="ui-button-info"
            (onClick)="openUserAssociationsColumn(association)">
          </p-button>
          <p-button
            class="association-edit-btn"
            pTooltip="{{ 'common.change_role' | translate }}"
            icon="fa fa-user"
            styleClass="ui-button-info"
            (onClick)="openChangeUserRoleDialog(association)">
          </p-button>
        </div>
      </div>
    </div>
  </div>

</div>

<p-dialog
  *ngIf="showAssociationDatesDialog"
  [(visible)]="showAssociationDatesDialog"
  [modal]="true"
  header="{{'common.manageAssociations' | translate}}"
  [minWidth]="700"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeAssociationDialog()">
  <app-association-dates-form
    [selectedAssociation]="selectedAssociation"
    (associationDates)="closeAssociationDatesForm($event)">
  </app-association-dates-form>
</p-dialog>

<p-dialog
  *ngIf="showAssociationMsBaseUrlDialog"
  [(visible)]="showAssociationMsBaseUrlDialog"
  [modal]="true"
  header="{{'common.manageAssociations' | translate}}"
  [minWidth]="700"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeAssociationDialog()">
  <app-association-msbaseurl-form
    [selectedAssociation]="selectedAssociation"
    (msBaseUrlChanged)="closeMsBaseUrlForm($event)">
  </app-association-msbaseurl-form>
</p-dialog>

<p-dialog
  *ngIf="showCreationDialog"
  [(visible)]="showCreationDialog"
  [modal]="true"
  [header]="creationDialogTitle"
  [minWidth]="700"
  [positionTop]="50"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeCreationDialog()">
  <app-user-form
    *ngIf="activeTab === 0"
    (userAdded)="userAdded($event)"
    (userUpdated)="userUpdated($event)"
    [dialogBoxUser]="srvUsers.userEditing"
    [userToClone]="userToClone"
  ></app-user-form>
  <app-company-form
    *ngIf="activeTab === 1"
    (companyAdded)="companyAdded($event)"
    (companyUpdated)="companyUpdated($event)"
    [dialogBoxCompany]="selectedCompany"
  ></app-company-form>
  <app-application-form
    *ngIf="activeTab === 2"
    (applicationAdded)="applicationAdded($event)"
    (applicationUpdated)="applicationUpdated($event)"
    [dialogBoxItem]="selectedApp"
  ></app-application-form>
</p-dialog>

<p-dialog
  *ngIf="showRoleChangeDialog"
  [(visible)]="showRoleChangeDialog"
  [modal]="true"
  header="{{ 'common.change_role' | translate }}"
  [minWidth]="500"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeChangeUserRoleDialog()">
  <app-change-users-role-form 
    [currentRoleUser]="selectedUserForRoleChange"
    (onRolesUpdate)="handleUpdateRoles($event)"
  >
  </app-change-users-role-form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/administration/associations-management/associations/associations.component.html